import React from 'react';
import { FormLabel } from 'react-bootstrap';
import Select from 'react-select';

const CustomSelect = ({
  options,
  value,
  onChange,
  error,
  title,
  labelKey = 'label',
  valueKey = 'value',
  labelClassName = '',
  hasDefaultOpt = false,
  required = false,
  isSearchable = true,
  isSm = false,
  controlStyle = {},
  style = {},
  getOptionLabel = (option) => option[labelKey],
  menuOnRight = false,
  menuOnLeft = false,
  fallbackLabel,
  ...others
}) => {
  const optionsList = hasDefaultOpt
    ? [{ [labelKey]: '-- Select --', [valueKey]: '' }, ...options]
    : options;

  // A saved value whose options haven't loaded yet must still display, not blank.
  const matchedOption =
    options?.find((option) => option[valueKey]?.toString() === value?.toString()) ?? null;
  const selectedValue =
    matchedOption ??
    (value !== '' && value != null
      ? { [valueKey]: value, [labelKey]: fallbackLabel ?? value }
      : '');

  // Custom styles for right-side menu
  const rightMenuStyles = menuOnRight
    ? {
        menu: (base, state) => ({
          ...base,
          borderRadius: '2px',
          zIndex: 9999,
          fontSize: isSm ? '.875rem' : base.fontSize,
          // Position menu to the right
          left: '100%',
          marginLeft: '8px',
          top: '50%',
          transform: 'translateY(-50%)',
          minWidth: '140px'
        }),
        menuList: (base) => ({
          ...base,
          maxHeight: '200px'
        })
      }
    : {};
  const leftMenuStyles = menuOnLeft
    ? {
        menu: (base, state) => ({
          ...base,
          borderRadius: '2px',
          zIndex: 9999,
          fontSize: isSm ? '.875rem' : base.fontSize,
          // Position menu to the right
          right: '80%',
          marginLeft: '8px',
          top: '50%',
          transform: 'translateY(-50%)',
          minWidth: '140px'
        }),
        menuList: (base) => ({
          ...base,
          maxHeight: '200px'
        })
      }
    : {};

  return (
    <div className="" style={menuOnRight || menuOnLeft ? { position: 'relative' } : {}}>
      {title && (
        <FormLabel className={labelClassName}>
          {title}
          {required && <span className="text-danger">*</span>}
        </FormLabel>
      )}
      <Select
        className="basic-single rounded-0"
        classNamePrefix="select"
        name="select"
        defaultValue=""
        placeholder="-- Select --"
        isSearchable={isSearchable}
        options={optionsList}
        getOptionLabel={getOptionLabel}
        getOptionValue={(option) => option[valueKey]}
        value={selectedValue}
        onChange={onChange}
        menuShouldScrollIntoView={false}
        menuPlacement={menuOnRight || menuOnLeft ? 'auto' : 'bottom'}
        menuPosition={menuOnRight || menuOnLeft ? 'absolute' : 'absolute'}
        styles={{
          control: (base, state) => ({
            ...base,
            minHeight: isSm ? '30px' : base.minHeight,
            borderRadius: '2px',
            borderWidth: '1px', // Default thin border
            borderColor: state.isFocused ? '#007bff' : '#ccc', // Custom focus color
            boxShadow: state.isFocused ? '0 0 2px #007bff' : 'none',
            fontSize: isSm ? '.875rem' : base.fontSize,
            backgroundColor: state.isDisabled ? '#e9ecef' : base.backgroundColor,
            ...controlStyle
          }),

          indicatorsContainer: (base) => ({
            ...base,
            height: isSm ? '28px' : base.height
          }),
          menu: (base) => ({
            ...base,
            borderRadius: '2px',
            zIndex: 9999,
            fontSize: isSm ? '.875rem' : base.fontSize,
            ...(menuOnRight && {
              left: '100%',
              marginLeft: '8px',
              top: '50%',
              transform: 'translateY(-50%)',
              minWidth: '200px'
            })
          }),
          placeholder: (provided) => ({
            ...provided,
            color: '#6c757d',
            fontSize: '14px',
            fontStyle: 'italic'
          }),
          singleValue: (provided, state) => ({
            ...provided,
            color: state.isDisabled ? '#000' : provided.color,
            ...(state.data?.[labelKey] === '-- Select --' && {
              color: '#6c757d',
              fontSize: '14px',
              fontStyle: 'italic'
            })
          }),
          ...rightMenuStyles,
          ...leftMenuStyles,
          ...style
        }}
        {...others}
      />
      {error && <small className="invalid-feedback d-block">{error}</small>}
    </div>
  );
};

export default CustomSelect;
